class VariantSelector {
    constructor(container) {
        this.container = container;
        this.productCards = container.querySelectorAll(".variant-product-card");
        this.selectedVariant = null;
        this.callbacks = { onVariantSelect: [] };
        this.init();
    }
    init() {
        this.productCards.forEach((card, index) => {
            card.addEventListener("click", () => {
                this.selectVariant(index);
            });
        });
        const selectedCard = this.container.querySelector(".variant-product-card.selected");
        if (!selectedCard && this.productCards.length > 0) {
            this.selectVariant(0);
        } else if (selectedCard) {
            const selectedIndex = Array.from(this.productCards).indexOf(selectedCard);
            this.selectedVariant = selectedIndex;
        }
    }
    selectVariant(index) {
        this.productCards.forEach((card) => {
            card.classList.remove("selected");
        });
        if (this.productCards[index]) {
            this.productCards[index].classList.add("selected");
            this.selectedVariant = index;
            const variantData = this.getVariantData(index);
            this.callbacks.onVariantSelect.forEach((callback) => {
                callback(variantData, index);
            });
            const event = new CustomEvent("variantSelected", {
                detail: { variant: variantData, index: index, element: this.productCards[index] },
            });
            this.container.dispatchEvent(event);
        }
    }
    getVariantData(index) {
        const card = this.productCards[index];
        if (!card) return null;
        return {
            title: card.querySelector(".variant-product-title")?.textContent?.trim() || "",
            description: card.querySelector(".variant-product-description")?.textContent?.trim() || "",
            originalPrice: card.querySelector(".variant-original-price")?.textContent?.trim() || "",
            currentPrice: card.querySelector(".variant-current-price")?.textContent?.trim() || "",
            hasBadge: !!card.querySelector(".variant-best-value-badge"),
            badgeText: card.querySelector(".variant-best-value-badge")?.textContent?.trim() || "",
            variantId: card.dataset.variantId || null,
            productId: card.dataset.productId || null,
            variantPrice: card.dataset.variantPrice || null,
            variantComparePrice: card.dataset.variantComparePrice || null,
            variantAvailable: card.dataset.variantAvailable === "true",
        };
    }
    getSelectedVariant() {
        if (this.selectedVariant !== null) {
            return this.getVariantData(this.selectedVariant);
        }
        return null;
    }
    onVariantSelect(callback) {
        this.callbacks.onVariantSelect.push(callback);
    }
    updateVariantColors(colors) {
        if (!colors) return;
        const root = this.container;
        Object.entries(colors).forEach(([property, value]) => {
            if (value) {
                root.style.setProperty(`--variant-${property.replace(/_/g, "-")}`, value);
            }
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    const variantContainers = document.querySelectorAll(".variant-selector-container");
    variantContainers.forEach((container) => {
        if (container.variantSelector) return;
        const variantSelector = new VariantSelector(container);
        container.variantSelector = variantSelector;
        
        // Set initial servings badge to first variant (30 servings)
        updateServingsBadge(1);
        
        // Set initial per serving badge to first variant
        updatePerServingBadge(1);
        variantSelector.onVariantSelect((variantData, index) => {
            console.log("Variant selected:", variantData);
            
            // Update servings badge based on selected variant
            updateServingsBadge(index + 1);
            
            // Update per serving badge based on selected variant
            updatePerServingBadge(index + 1);
            
            if (variantData.variantId) {
                const productForm = document.querySelector('form[action*="/cart/add"]');
                if (productForm) {
                    const variantInput = productForm.querySelector('input[name="id"], select[name="id"]');
                    if (variantInput) {
                        if (variantInput.tagName === "SELECT") {
                            variantInput.value = variantData.variantId;
                        } else {
                            variantInput.value = variantData.variantId;
                        }
                        variantInput.dispatchEvent(new Event("change", { bubbles: !0 }));
                    }
                }
                if (window.history && window.history.replaceState) {
                    const url = new URL(window.location);
                    url.searchParams.set("variant", variantData.variantId);
                    window.history.replaceState({}, "", url);
                }
                const priceElements = document.querySelectorAll(".price, .product-price, [data-price]");
                priceElements.forEach((el) => {
                    if (variantData.currentPrice) {
                        el.textContent = variantData.currentPrice;
                    }
                });
                window.dispatchEvent(new CustomEvent("variantChanged", { detail: variantData }));
            }
            setTimeout(() => {
                updateSubscriptionSelector(variantData);
                // Restore subscription button price after variant change
                if (document.querySelector('.ev-subscription-selector-container')) {
                    updateButtonPrice();
                }
            }, 300);
        });
    });
});
window.createVariantSelector = function (container, options = {}) {
    const variantSelector = new VariantSelector(container);
    if (options.colors) {
        variantSelector.updateVariantColors(options.colors);
    }
    if (options.onSelect) {
        variantSelector.onVariantSelect(options.onSelect);
    }
    return variantSelector;
};


function updateServingsBadge(selectedIndex) {
    const servingsBadge = document.querySelector('.variant-servings-badge');
    if (servingsBadge) {
        const servings = selectedIndex * 30; // 30, 60, 90 for variants 1, 2, 3
        servingsBadge.textContent = `${servings} Servings`;
    }
}

function updatePerServingBadge(selectedIndex) {
    const perServingBadge = document.querySelector('.ev-per-serving-badge');
    if (perServingBadge) {
        // Get the selected variant card
        const selectedCard = document.querySelector('.variant-product-card.selected');
        if (selectedCard) {
            const currentPriceElement = selectedCard.querySelector('.variant-current-price');
            if (currentPriceElement) {
                // Extract price value (remove currency symbols and parse)
                const priceText = currentPriceElement.textContent.trim();
                const priceValue = parseFloat(priceText.replace(/[^0-9.]/g, ''));
                
                if (!isNaN(priceValue)) {
                    // Calculate price per serving (price / number of servings)
                    const servings = selectedIndex * 30;
                    const pricePerServing = priceValue / servings;
                    
                    // Format the price per serving (assuming currency is same as original)
                    const currencySymbol = priceText.match(/[^\d.]/)?.[0] || '$';
                    const formattedPrice = currencySymbol + pricePerServing.toFixed(2);
                    
                    perServingBadge.textContent = `${formattedPrice} per serving`;
                }
            }
        }
    }
}

function updateSubscriptionSelector(variantData) {
    if(document.querySelectorAll('.ev-subscription-selector-container').length > 0 && document.querySelectorAll('.sls-option-container').length > 0){
        let comparePrice1 = document.querySelector('.variant-product-card.selected').querySelector('.variant-original-price').textContent;
        if (comparePrice1) {
            document.querySelectorAll('.ev-subscription-option')[0].querySelector('.ev-subscription-original-price').textContent = comparePrice1;
            document.querySelectorAll('.ev-subscription-option')[1].querySelector('.ev-subscription-original-price').textContent = comparePrice1;
        }
        let price1 = document.querySelectorAll('.sls-option-container')[0].querySelector('.sls-price .seal-money').innerHTML;
        if (price1) {
            document.querySelectorAll('.ev-subscription-option')[1].querySelector('.ev-subscription-discounted-price').textContent = price1;
        }
        let price2 = document.querySelectorAll('.sls-option-container')[1].querySelector('.sls-price .seal-money').innerHTML;
        let savingBadge2 = document.querySelectorAll('.sls-option-container')[1].querySelector('.sls-savings-badge').innerHTML;
        if (price2) {
            document.querySelectorAll('.ev-subscription-option')[0].querySelector('.ev-subscription-discounted-price').textContent = price2;
        }
        if(savingBadge2){
            document.querySelectorAll('.ev-subscription-option')[0].querySelector('.ev-subscription-savings-badge').textContent = savingBadge2;
        }
    }
}